import { useSelector } from 'react-redux';
import { chessViewMode } from '../constants/chessViewMode';
import {
  acceptanceStatusesBorderColorsMap,
  constructionBorderColorMap,
  internalAcceptanceBorderColorMap,
} from '../constants/stagesColorMaps';

const stagesEnum = {
  acceptance: 3, // приемка
  internalAcceptance: 2, // внутренняя приемка
  construction: 1, // строительство
};

const useBorderColorForStages = () => {
  const { monitoringStage, chessViewColorMode } = useSelector(
    (state) => state.housingStockStore
  );

  if (chessViewColorMode !== chessViewMode.applicationMonitoring) return null;

  switch (monitoringStage) {
    case stagesEnum.construction:
      return [
        {
          id: 1,
          value: 'Идут работы',
          bg: constructionBorderColorMap.get(1),
        },
        {
          id: 2,
          value: 'Работы завершены',
          bg: constructionBorderColorMap.get(2),
        },
      ];
    case stagesEnum.internalAcceptance:
      return [
        {
          id: 3,
          value: 'Не готова к передаче',
          bg: internalAcceptanceBorderColorMap.get(3),
        },
        {
          id: 4,
          value: 'Готова к передаче',
          bg: internalAcceptanceBorderColorMap.get(4),
        },
      ];
    case stagesEnum.acceptance:
      return [
        {
          id: 4,
          value: 'Односторонняя передача',
          bg: acceptanceStatusesBorderColorsMap.get(4),
        },
        {
          id: 3,
          value: 'Принято',
          bg: acceptanceStatusesBorderColorsMap.get(3),
        },
        {
          id: 2,
          value: 'Принято с замечаниями',
          bg: acceptanceStatusesBorderColorsMap.get(2),
        },
        {
          id: 1,
          value: 'Не принято',
          bg: acceptanceStatusesBorderColorsMap.get(1),
        },
      ];
    default:
      return null;
  }
};

export default useBorderColorForStages;
